// Common degrees list — used by Candidate Portal Dossier Education section.
// Candidates can pick "Other" and type a custom degree.
export const DEGREES = [
  "Bachelor of Science (B.S.)",
  "Bachelor of Arts (B.A.)",
  "Bachelor of Engineering (B.E.)",
  "Bachelor of Technology (B.Tech)",
  "Bachelor of Business Administration (B.B.A.)",
  "Bachelor of Commerce (B.Com)",
  "Bachelor of Fine Arts (B.F.A.)",
  "Bachelor of Architecture (B.Arch)",
  "Master of Science (M.S.)",
  "Master of Arts (M.A.)",
  "Master of Engineering (M.E.)",
  "Master of Technology (M.Tech)",
  "Master of Business Administration (M.B.A.)",
  "Master of Commerce (M.Com)",
  "Master of Fine Arts (M.F.A.)",
  "Master of Public Health (M.P.H.)",
  "Master of Public Administration (M.P.A.)",
  "Doctor of Philosophy (Ph.D.)",
  "Doctor of Medicine (M.D.)",
  "Doctor of Education (Ed.D.)",
  "Juris Doctor (J.D.)",
  "Associate Degree",
  "Diploma / Certificate",
  "High School Diploma",
  "Other",
];

export const DEGREE_OTHER = "Other";
